import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { PharmaciesFiltersContext } from '../../../../context/PharmaciesFiltersContext'
import ChartDonut from '../../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'

const GET_PERCENTAGE_ANTIFRAUDE = gql`
  query PercentageAntifraude($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      aggs: {
        counter: {
          value_count: {
            field: "pharmacy_name.keyword"
          }
        },
        status: {
          terms: {
            field: "antifraud.status.keyword",
            size: 10
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number
}
const PercentageAntiFraud = (): JSX.Element => {
  const { filters } = useContext(PharmaciesFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_PERCENTAGE_ANTIFRAUDE, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data) return <ChartDonutSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.status
  const labels: Array<string> = []
  const series: Array<number> = []

  buckets.map((bucket: Bucket) => {
    labels.push(bucket.key)
    return series.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'status-antifraud'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        let total = 0
        opts.w.globals.series.map((serie: any) => {
          total += serie
        })

        return [' ', seriesName, ' - ', formatNumber((opts.w.globals.series[opts.seriesIndex] / total) * 100, 2), '%']
      },
      width: 275,
      height: 300
    },
    dataLabels: {
      formatter: function (value: number) {
        return `${formatNumber(value, 2)}%`
      }
    },
    tooltip: {
      y: {
        formatter: function (value: number) {
          return formatNumber(value, 0)
        }
      }
    }
  }

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      Status do antiFraude nas farmácias
    </Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.blue} type="donut" />
  </Paper>
}

export default PercentageAntiFraud
